import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InputTextModule } from 'primeng/inputtext';
import { SidebarModule } from 'primeng/sidebar';
import { BadgeModule } from 'primeng/badge';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputSwitchModule } from 'primeng/inputswitch';
import { RippleModule } from 'primeng/ripple';
import { AppMenuComponent } from './app.menu.component';
import { AppMenuitemComponent } from './app.menuitem.component';
import { RouterModule } from '@angular/router';
import { AppTopBarComponent } from './app.topbar.component';
import { AppFooterComponent } from './app.footer.component';
import { AppConfigModule } from './config/config.module';
import { AppSidebarComponent } from "./app.sidebar.component";
import { AppLayoutComponent } from "./app.layout.component";
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { StopwatchModule } from '../components/additionals/stopwatch/stopwatch.module';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { DialogModule } from 'primeng/dialog';
import { AvatarModule } from 'primeng/avatar';
import { FileUploadModule } from 'primeng/fileupload';
import { ToastModule } from 'primeng/toast';
import { DropdownModule } from 'primeng/dropdown';
import { ProcessHubService } from '../aplication/api/Services/Process.hub.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LottieComponent } from 'ngx-lottie';
import { PasswordModule } from 'primeng/password';

@NgModule({
    declarations: [
        AppMenuitemComponent,
        AppTopBarComponent,
        AppFooterComponent,
        AppMenuComponent,
        AppSidebarComponent,
        AppLayoutComponent,
    ],
    exports: [AppLayoutComponent],
    imports: [BrowserModule,
        FormsModule,
        BrowserAnimationsModule,
        InputTextModule,
        SidebarModule,
        BadgeModule,
        RadioButtonModule,
        ReactiveFormsModule,
        InputSwitchModule,
        RippleModule,
        RouterModule,
        ButtonModule,
        LottieComponent,
        DividerModule,
        StopwatchModule,
        OverlayPanelModule,
        AppConfigModule,
        ProgressSpinnerModule,
        DialogModule,
        PasswordModule,
        AvatarModule,
        FileUploadModule,
        ToastModule,
        DropdownModule
    ],
    providers: [provideHttpClient(withInterceptorsFromDi())] })
export class AppLayoutModule { }
